import React from 'react';
import * as _ from 'lodash';
import dialogLoader from '../../utilities/dialogLoader';
import { CcusFieldDataLoadDialog } from '../modals/CcusFieldDataLoadDialog';
import { CcusConnectingDialog } from '../modals/CcusConnectingDialog';
import { BackgroundLayer } from '../modals/BackgroundLayer';
import { ccusStore } from '../FieldFormElementsCcusProvider';
import FieldCcusApi from '../../services/FieldCcus';
import SessionStorageService from '../../services/utilities/SessionStorageService';
import { setWaitTime } from '../../utilities/commonUtil';
import { STATUS_CODE, TIME_OUT_TWO_SECOND } from '../../utilities/constants';
import { Confirmation } from '../modals/common';
import { FormListSubHeader } from '../CommonFormComponents';
import { CcusTitleBlock } from '../CcusFormComponent';
import { FormInformationDialog } from '../FormInformationDialog';
import { messageUtility } from '../../utilities/messageUtility';
import Tippy, { ToolTip } from '../ReactTippy';

// CCUS現場情報ダミーデータ  ローカル(CCUSとの連携ができない場合)で実装する場合に利用してください
// const sample_response = {
//   result: true,
//   status: 0,
//   message: '',
//   data: {
//     total: 1,
//     entities: {
//       ccus_field: {
//         id: 29182721621,
//         jigyousya_id: '47893601732071',
//         manager_id: '28723388363022',
//         certify_system_id: '418',
//         apply_date: '2019-02-06',
//         site_name: '甲町小学校建設現場',
//         site_tel_number: '03-2222-0001',
//         site_fax_number: null,
//         site_address_zip_cd: '1601251',
//         site_address_prefecture: '東京都',
//         site_address_city: '新宿区',
//         site_address_add1: '柏木201',
//         site_address_add2: null,
//         site_address_prefecture_kana: 'トウキョウト',
//         site_address_city_kana: 'シンジュクク',
//         site_address_add1_kana: 'カシワギ201',
//         site_address_add2_kana: null,
//         working_record_start_date: '2018-12-01',
//         working_record_end_date: '2020-12-31',
//         order_type_code: '3',
//         work_category_code_not_entry: '1',
//         created_at: '2019-07-09T08:37:46.000+09:00',
//         updated_at: '2019-07-18T09:34:00.000+09:00',
//         ccus_field_managers: [
//           {
//             id: 23,
//             info_seq: '0',
//             info_main_flg: 1,
//             manager_id: '45956501654922',
//             user_type: '304',
//             kana_last_name: null,
//             kana_first_name: null,
//             kana_middle_name: null,
//             last_name: '現管',
//             first_name: '元郎005',
//             middle_name: null,
//             department_name: null,
//             tel_number: '03-1111-0000',
//             email_address: 'support@auth.ccus.jp',
//             created_at: '2019-07-18T09:34:00.000+09:00',
//             updated_at: '2019-07-18T09:34:00.000+09:00',
//           },
//         ],
//       },
//     },
//   },
// };

/**
 * CCUS連携フォーム
 */
export class FieldCcusForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      company_id: SessionStorageService.getCompanyId(),
      ccus_connecting_dialog: false, //CCUS通信中ダイアログの表示フラグ
      data: null,
      ccus_state_management_id: null,
      ccus_field_id: null,
      same_site_id_other_fields_ids: null,
      isShowDupCcusFieldConfirmDialog: false,
      isShowCcusConfirmDialog: false,
      isConnectedCcus: false,
    };

    this.event = {
      clearCcusId: this.clearCcusId.bind(this),
    };

    this.field_format = {
      field: {},
      ccus_field_managers: {},
    };
  }

  clearCcusId() {
    this.setState({ data: null });
    this.props.setCcusFieldData(this.field_format);
  }

  /**
   * CCUSエラー(CCUS通信エラー,CCUS現場情報取得エラー)ダイアログを表示
   *
   * @param {string} response responseデータ
   */
  showCcusErrorDialog(response) {
    let message = '';

    // responseによりメッセージの階層が変わるのでチェックして設定
    if (_.isEmpty(response.message)) {
      if (response.data !== undefined && response.data !== null) {
        message = response.data.message;
      }
    } else {
      message = response.message;
    }

    return new Promise(resolved => {
      dialogLoader.show(FormInformationDialog, {
        title: messageUtility.getMessage('I-002-004-05'),
        message,
        onClose: () => {
          dialogLoader.close();
          resolved(true);
          window.location.reload();
        },
      });
    });
  }

  /**
   * ccus現場id入力ダイアログ
   */
  showCcusConnectDialog() {
    if (this.props.ccusSecededFlag) {
      return;
    }
    dialogLoader.show(CcusFieldDataLoadDialog, {
      value: {},
      callback: {
        back: () => {
          dialogLoader.close();
        },
        submit: async params => {
          dialogLoader.close();
          const apiParams = {
            ccus_field_id: params.ccusid,
            field_id: this.props.fieldId,
            from_ccus_cooporation_page: false,
          };
          //CCUS接続中ダイアログ表示
          this.setState({ ccus_connecting_dialog: true }, () => {
            const state = { ...this.state };
            //CCUS情報API
            FieldCcusApi.beginFetchCcusFieldData(apiParams)
              .then(response => {
                if (response.result) {
                  if (response.data.entities.same_site_id_other_fields_ids) {
                    state.same_site_id_other_fields_ids =
                      response.data.entities.same_site_id_other_fields_ids;
                    state.ccus_state_management_id =
                      response.data.entities.ccus_state_management_id;
                    state.ccus_field_id = response.data.entities.ccus_field_id;
                    state.ccus_connecting_dialog = false;
                    state.isShowDupCcusFieldConfirmDialog = true;
                  } else {
                    this.monitoringFetchCcusFieldData(
                      response.data.entities.ccus_state_management_id,
                      response.data.entities.ccus_field_id
                    );
                  }
                } else {
                  this.showCcusErrorDialog(response);
                  state.ccus_connecting_dialog = false;
                }
              })
              .catch(error => {
                this.showCcusErrorDialog(error);
                state.ccus_connecting_dialog = false;
              })
              .finally(() => {
                this.setState(state);
              });
          });
        },
      },
    });
  }

  /**
   * CCUS現場情報取得状況を監視する
   * @param {number} ccusStateManagementId CCUSステータス管理ID
   * @param {string} ccusFieldId CCUS現場ID
   * */
  monitoringFetchCcusFieldData = (ccusStateManagementId, ccusFieldId) => {
    setWaitTime(TIME_OUT_TWO_SECOND)
      .then(() => {
        const params = {
          ccus_state_management_id: ccusStateManagementId,
          ccus_field_id: ccusFieldId,
        };
        const state = { ...this.state };
        FieldCcusApi.fetchCcusFieldData(params)
          .then(response => {
            if (response.result) {
              if (response.status === STATUS_CODE.ok) {
                // ステータスコードが正常(200)の場合
                state.data = this.getCcusFieldData(response);
                state.ccus_connecting_dialog = false;
                state.isShowCcusConfirmDialog = true;
              } else if (response.status === STATUS_CODE.accepted) {
                // ステータスコードが処理中(202)の場合
                // 再度現場情報取得状況を監視する
                this.monitoringFetchCcusFieldData(
                  ccusStateManagementId,
                  ccusFieldId
                );
              } else {
                this.showCcusErrorDialog(response);
                state.ccus_connecting_dialog = false;
              }
            } else {
              this.showCcusErrorDialog(response);
              state.ccus_connecting_dialog = false;
            }
          })
          .catch(error => {
            this.showCcusErrorDialog(error);
            state.ccus_connecting_dialog = false;
          })
          .finally(() => {
            this.setState(state);
          });
      })
      .catch();
  };

  /**
   * set ccus data for field form
   */
  submit = () => {
    this.props.setCcusFieldData(this.state.data);
    this.setState({
      isShowCcusConfirmDialog: false,
      isShowDupCcusFieldConfirmDialog: false,
      isConnectedCcus: true,
    });
  };

  /**
   * get ccus data from api response
   * @return {object} CCUS現場情報
   */
  getCcusFieldData(response) {
    //tel,fax,postal-codeにハイフンを追加
    const strInsert = (str, index, val) => {
      return str.slice(0, index) + val + str.slice(index);
    };

    //CCUSのキー名と現場APIのキー名が違うためここで現場APIのキー名に合わせる
    const field = response.data.entities.ccus_field;
    const ccusField = response.data.entities.ccus_field;

    //郵便番号にハイフンを追加
    let postal_code = '';
    if (
      field.site_address_zip_cd !== undefined &&
      field.site_address_zip_cd !== null
    ) {
      postal_code = strInsert(field.site_address_zip_cd, 3, '-');
    }
    //管理者
    let manager_id = '';
    const managers = _.cloneDeep(field.ccus_field_managers);

    //複数人の場合
    if (managers.length > 1) {
      const _managers = _.filter(managers, manager => {
        return manager.info_main_flg == 1; //主の人
      });
      //主がいた場合
      if (_managers.length > 0) {
        manager_id = _managers[0].manager_id;
      } else {
        //主がいない場合
        manager_id = managers[0].manager_id;
      }
      //一人しかいない場合
    } else if (managers.length === 1) {
      manager_id = managers[0].manager_id;
    }

    return {
      field: {
        name: ccusField.site_name,
        ordering_type_id: ccusField.order_type_code,
        construction_type_id: ccusField.work_category_code_not_entry,
        postal_code,
        address_prefecture: ccusField.site_address_prefecture,
        address_prefecture_kana: ccusField.site_address_prefecture_kana,
        address_city: ccusField.site_address_city,
        address_city_kana: ccusField.site_address_city_kana,
        address_add_1: ccusField.site_address_add1,
        address_add_1_kana: ccusField.site_address_add1_kana,
        address_add_2: ccusField.site_address_add2,
        address_add_2_kana: ccusField.site_address_add2_kana,
        tel: ccusField.site_tel_number,
        office_postal_code: postal_code,
        office_address_prefecture: ccusField.site_address_prefecture,
        office_address_prefecture_kana: ccusField.site_address_prefecture_kana,
        office_address_city: ccusField.site_address_city,
        office_address_city_kana: ccusField.site_address_city_kana,
        office_address_add_1: ccusField.site_address_add1,
        office_address_add_1_kana: ccusField.site_address_add1_kana,
        office_address_add_2: ccusField.site_address_add2,
        office_address_add_2_kana: ccusField.site_address_add2_kana,
        groundbreaking_date: ccusField.working_record_start_date,
        complete_schedule_date: ccusField.working_record_end_date,
      },
      ccus_field_managers: {
        manager_id,
      },
      company_branch: {},
      ccus_field_id: ccusField.id,
    };
  }

  /**
   * CCUS連携通信中ダイアログ
   */
  showCcusConnectingDialog() {
    return this.state.ccus_connecting_dialog ? (
      <BackgroundLayer
        modalRoot='root'
        modalState={this.state.ccus_connecting_dialog}
      >
        <CcusConnectingDialog />
      </BackgroundLayer>
    ) : null;
  }
  /**
   * 全てのデータをフォームに転記
   */
  setAllDataToForm() {
    const validate = this.props.validate || {};
    _.each(Object.keys(this.state.data.field), key => {
      validate[key] && delete validate[key];
    });
    this.props.setValidate(validate, () => {
      //現場情報
      _.each(this.state.data.field, (value, key) => {
        ccusStore.set(key, value);
        this.props.updateFormValue(key, value);
      });
      //ccus管理者id
      ccusStore.set(
        'manager_id',
        this.state.data.ccus_field_managers.manager_id
      );
      this.props.updateFormValue(
        'manager_id',
        this.state.data.ccus_field_managers.manager_id
      );
    });
  }

  /**
   * get field address from ccus data
   * @returns {string}
   */
  getFieldAddress = () => {
    if (_.isEmpty(_.get(this.state, 'data.field'))) {
      return;
    }
    const {
      address_prefecture,
      address_city,
      address_add_1,
      address_add_2,
    } = _.get(this.state, 'data.field');
    return `${address_prefecture || ''}${address_city || ''}${address_add_1 ||
      ''}${address_add_2 || ''}`;
  };

  render() {
    const { ccusid, disabled, fieldName, ccusSecededFlag } = this.props;
    const ccusComponents = () => {
      return (
        <React.Fragment>
          {this.state.isConnectedCcus && ccusid && (
            <CcusTitleBlock
              onClick={e => {
                e.preventDefault();
                this.setAllDataToForm();
              }}
            />
          )}
        </React.Fragment>
      );
    };
    return disabled ? (
      <FormListSubHeader title='工事基本情報' noMarginTop={true} />
    ) : (
      <React.Fragment>
        <div className='FieldCcusForm'>
          <FormListSubHeader
            title='工事基本情報'
            noMarginTop={true}
            ccusComponent={ccusComponents()}
          />
          {_.isEmpty(ccusid) && (
            <div className='btn-connect-ccus'>
              <Tippy
                duration={10}
                distance={24}
                arrow={true}
                delay={[500, 0]}
                placement='top'
                disable={!ccusSecededFlag}
                html={
                  <ToolTip tooltipStyle={{ whiteSpace: 'pre' }}>
                    {messageUtility.getMessage('I-000-243')}
                  </ToolTip>
                }
              >
                <div>
                  <button
                    className={`btn--sub ${
                      ccusSecededFlag ? 'btn--disabled' : ''
                    }`}
                    onClick={() => {
                      this.showCcusConnectDialog();
                    }}
                    disabled={ccusSecededFlag}
                  >
                    CCUS現場情報を取得
                  </button>
                </div>
              </Tippy>
            </div>
          )}
        </div>
        {this.showCcusConnectingDialog()}
        <Confirmation
          visible={this.state.isShowCcusConfirmDialog}
          rootClassName='dialog--wide FieldCcusConfirmDialog'
          title={messageUtility.getMessage('I-000-176')}
          message={
            <React.Fragment>
              取得した現場情報に間違いがないかご確認ください。
              <br />
              <br />
              取得した現場情報
              <p className='info-text'>
                CCUS現場ID：{_.get(this.state, 'data.ccus_field_id')}
                <br />
                現場名：{_.get(this.state, 'data.field.name')}
                <br />
                現場住所：{this.getFieldAddress()}
              </p>
              {fieldName && (
                <div>
                  現在操作中の現場情報
                  <p className='info-text'>現場名：{fieldName}</p>
                </div>
              )}
            </React.Fragment>
          }
          confirmButtonText={messageUtility.getMessage('I-000-177')}
          cancelButtonText={messageUtility.getMessage('I-000-178')}
          effectiveButtonClassName='btn--sub'
          onCancel={() => {
            this.setState({
              data: null,
              isConnectedCcus: false,
              isShowCcusConfirmDialog: false,
              isShowDupCcusFieldConfirmDialog: false,
            });
          }}
          onConfirm={this.submit}
        />
        <Confirmation
          visible={this.state.isShowDupCcusFieldConfirmDialog}
          rootClassName='dialog--wide FieldCcusConfirmDialog'
          title={messageUtility.getMessage('I-000-221')}
          message={
            <React.Fragment>
              以下の現場で同じCCUS現場IDが設定されています。
              <br />
              入力したCCUS現場IDに誤りがないかご確認ください。
              <br />
              <br />
              <p>
                ＜入力されたCCUS現場ID＞
                <br />
                CCUS現場ID：{this.state.ccus_field_id}
                <br />
                <br />
                ＜同じCCUS現場IDが設定された現場＞
                <ul className='fields-list'>
                  {_.map(
                    this.state.same_site_id_other_fields_ids,
                    (fieldId, idx) => {
                      return <li key={idx}>Buildeeの現場ID：{fieldId}</li>;
                    }
                  )}
                </ul>
              </p>
              ※上記の現場にアクセス権がなく現場一覧に表示されない場合、本社管理者または支店管理者にご確認ください。
              <br />
              ※複数の現場で同じCCUS現場IDを設定し、入退場実績の送信などを行うことができますが、施工体制連携は１つの現場からしか行うことができません。
            </React.Fragment>
          }
          confirmButtonText={messageUtility.getMessage('I-000-177')}
          cancelButtonText={messageUtility.getMessage('I-000-178')}
          effectiveButtonClassName='btn--sub'
          onCancel={() => {
            this.setState({
              data: null,
              isConnectedCcus: false,
              isShowDupCcusFieldConfirmDialog: false,
            });
          }}
          onConfirm={() => {
            this.monitoringFetchCcusFieldData(
              this.state.ccus_state_management_id,
              this.state.ccus_field_id
            );
            this.setState({
              isShowDupCcusFieldConfirmDialog: false,
              ccus_connecting_dialog: true,
            });
          }}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/forms/FieldCcusForm.jsx